import * as React from "react";
const SvgXCalendar = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m10.5 3.5-7 7M3.5 3.5l7 7", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgXCalendar;
